import cloneDeep from "lodash/cloneDeep"
import { getRouteDates } from '../shared/services/service.intellegence'

const PLAY_ROUTE = 'PLAY_ROUTE'
const PAUSE_ROUTE = 'PAUSE_ROUTE'
const SET_CURRENT_POINT = 'SET_CURRENT_POINT'
const CLEAR_PLAYER_DATA = 'CLEAR_PLAYER_DATA'

const playRouteAction = () => {
  return {
    type: PLAY_ROUTE
  }
}

const pauseRouteAction = () => {
  return {
    type: PAUSE_ROUTE
  }
}

const playRoute = () => {
  return (dispatch) => {
    dispatch(playRouteAction())
  }
}

const pauseRoute = () => {
  return (dispatch) => {
    dispatch(pauseRouteAction())
  }
}

const setCurrentPointAction = (index, date) => {
  return {
    type: SET_CURRENT_POINT,
    payload: { index, date }
  }
}

const setCurrentPoint = (index, date) => {
  return (dispatch) => {
    dispatch(setCurrentPointAction(index, date))
  }
}

const clearPlayerDataAction = () => {
  return {
    type: CLEAR_PLAYER_DATA
  }
}

const clearPlayerData = () => {
  return (dispatch) => {
    dispatch(clearPlayerDataAction())
  }
}

export {
  playRoute,
  playRouteAction,
  PLAY_ROUTE,

  pauseRoute,
  pauseRouteAction,
  PAUSE_ROUTE,

  setCurrentPoint,
  setCurrentPointAction,
  SET_CURRENT_POINT,

  clearPlayerData,
  clearPlayerDataAction,
  CLEAR_PLAYER_DATA
}